import { IChannelNotificationResponse } from "@wingspanhq/notifications/dist/lib/interfaces";
import { selectorActiveNotifications } from "./selectorActiveNotifications";

import { NotificationHandleType } from "../components/Notifications";
import { RequirementToApproveContext } from "../components/Notifications/templates/RequirementPendingReviewClient";

export const selectorRequirementsToApproveNotifications = (
  responses: IChannelNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return (
      response.handle === NotificationHandleType.RequirementPendingReviewClient
    );
  }) as Array<
    Omit<IChannelNotificationResponse, "context"> & {
      context: RequirementToApproveContext;
    }
  >;
};
